module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062568366_Contents#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There was a giant robot dinosaur smashing its way toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You might be wondering how I got here, sitting in a pile of peanut butter jars in the grocery store while people ran screaming in every direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ll tell you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been ten terribly lonely days since I lost my genie, Ridge, who disappeared back into his jar once our quest was over. Chasm, the newly freed all-powerful genie bent on world domination, escaped his cave prison—and I got left behind. Luckily, the hole he had blasted to get out of the cave led to the street right outside the Museum of Cans, Crates, Cartons, and Containers, and that strange curator guy was still around. Apparently, he no longer needed to guard the museum, since the undiscovered cave had been, well . . . discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took pity on me and asked where he could drop me off. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("I told him Nebraska, assuming Tina’s mom would still be there and that she had the magic trinket I needed to set everything right.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The curator drove me the whole way in the museum van, which was actually a very frightening experience, since he didn’t really know how to drive. It shouldn’t have taken us so many days, but I was terrible at giving directions since I still couldn’t tell left from right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went to St. Mercy’s Hospital first, made some inquiries, and eventually found the rural town that Tina and her mom called home. From there it was pretty easy to locate the correct house. There really weren’t that many to choose from. I thanked the curator and told him that I needed to do this next part on my own. The strange man wiggled his unibrow and drove off into the sunset.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Right as I was about to knock on the door, Ms. Gomez pulled out of the garage. Lucky for me, she wasn’t going far. I chased her a few blocks to the neighborhood grocery store and followed her inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But how was I supposed to start this conversation?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Ms. Gomez. You must be Tina’s mom. I know, because I spied on you in the hospital when you were terminally ill. My name’s Ace. I’m friends with your daughter. Or at least I was before she got enslaved by an evil genie called Chasm. Anyway, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("I’m here to break your favorite necklace. . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No. It would be easier to avoid such a conversation altogether. It would be easier to corner Maria Gomez, take her by surprise, break the chain, and run for it. Tina could explain everything to her mom after I saved her. But first, I needed to get my genie back before Chasm did anything crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hadn’t seen any major catastrophes on the news, so Chasm seemed to be biding his time. I knew the evil genie was somewhere out there. But where? I was sure Chasm had hundreds of nefarious plans cooked up from his millennia of entrapment inside his jar. So, what was he waiting for?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched Ms. Gomez pick out a shopping cart, tucking a strand of jet-black hair behind her upside-down ear. As an ex-Wishmaker, she still carried consequences like that from her youth. I could relate. I, too, had a few unfortunate consequences that would be sticking with me forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I looked at her now, it was hard to believe she’d ever been sick. Tina had cured her mom’s illness with a wish, and she looked perfectly healthy. Ms. Gomez wasn’t very tall, and pleasantly plump, but seemed plenty strong as she yanked apart two shopping carts that had been stuck together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crept up behind her as she stopped to pick out a loaf of bread. Tina’s note said she had made a wish to turn her mother’s necklace into the trinket that would reunite me with my genie. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("I saw the thin chain glinting around Ms. Gomez’s neck. A sharp tug should easily snap it. Of course, Tina would suffer some kind of nasty consequence in the same moment, but she’d known the risks when she wished for the trinket.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced from side to side to make sure no one was watching. Only then did I realize which aisle we were in. Where fate (or the Universe) had brought me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The peanut butter aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I moved in as Ms. Gomez stooped to set the bread into her cart. She turned as I leaped toward her, but I was too fast. My fingers brushed her neck as I snatched the chain. My momentum kept me going down the aisle. I heard her gasp, felt the necklace go tight in my grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chain snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought for sure I was safe, but Ms. Gomez whirled with surprising speed, the shopping cart rolling away as she caught me by the arm. I was jerked around, barely getting my feet under me as we came face-to-face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I probably looked really sick to her. Old consequences meant that my ragged breath smelled like fish, my right eye was yellow, my tongue was green, and my face was smudged with a bit of dried peanut butter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have any idea what you’ve done?” Ms. Gomez whispered, her voice carrying a definite Spanish accent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("“Do you like toast?” I said. Not because I wanted to sound like a smart aleck. The Universe forced me to answer any question with another question. I still had the rest of the year until that consequence let up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mismatched eyes fixed on the necklace dangling from my fist. Good. I could see where the chain had broken. Ridge’s jar should be on its way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can have it back,” I said, opening my fingers and letting it fall from my sweaty hand. Behind me, there was a thump as something fell to the hard floor of the grocery aisle. Craning my neck against Ms. Gomez’s iron grip, I saw what had made the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a solitary peanut butter jar that had seemingly leaped from the shelf like an anxious volunteer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A grin spread across my face as the jar wobbled upright. I could see the bright warning label from where I stood. No other peanut butter jar came with a warning. That was it. Ridge! All I had to do was twist off that lid and my genie would be back!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s okay,” I said. “I’m a Wishmaker. Or, I "), _c('i', [_vm._v("was")]), _vm._v(" one. And I’m about to be again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That necklace was a trinket,” Ms. Gomez cut me off, still holding my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” I answered. “That’s why I had to break it. That was the only way to find my genie again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“That’s not what it does!” Her face twisted in confusion, but her grip finally relaxed enough for me to pull free.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” I replied, crossing to pick up Ridge’s jar. “The trinket worked perfectly.” It felt right to hold the jar again. But my grip also brought back the dreaded responsibility of being a Wishmaker. The power of the Universe at my fingertips . . . in exchange for consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But the necklace,” Ms. Gomez said, pointing at the broken chain on the floor. “I took that trinket from a very bad Wishmaker nearly eight years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was she talking about? I picked nervously at the edge of the jar’s warning label, feeling the edge of the sticker begin to peel up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Gomez’s eyes suddenly grew wide. “Fudge ripple!” she shouted, stooping to lift the chain from the floor. “It’s a double trinket!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Double trinket?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You wished for this necklace to become a trinket,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not me,” I replied. Should I tell her about Tina? “It was—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does it do?” Ms. Gomez interrupted me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t I already say?” I answered with a mandatory question. “Breaking the chain reunited me with my genie.” As proof, I held up the jar of peanut butter, the half-peeled warning label curling up like a scroll.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("“Then you better open that quickly,” Ms. Gomez stated. “We’re going to need a genie to get away from the trinket’s original purpose.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was its original purpose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Wishmaker I took this from loved chaos.” Ms. Gomez gave a worried glance down the grocery store aisle. “When the chain breaks, the trinket releases a creature capable of mass destruction.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swallowed hard. “What kind of creature?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that’s how the giant robot dinosaur got there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The shelves behind Ms. Gomez erupted. She crumpled to the floor as bagged loaves of bread flew like shrapnel. The force of the impact tossed me backward and I slammed into the rack behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plastic jars of peanut butter cascaded upon my stunned form, burying me nearly to the neck. I shook my head against the blow and lifted my hands, only then realizing that I had dropped Ridge’s jar. No worries. I just needed to find the jar with the warning label on the lid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, right. The label was stuck to my thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another loud crack, and a nearby shelf exploded, sending deadly canned goods flying in every direction. That’s when people started running from the store, screaming. I don’t know what they thought was going on. The Universe "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("always shielded ordinary people, making magical things seem somehow explainable. But I was no ordinary person. I was an ex-Wishmaker.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, I think that catches you up on my current situation. Now, any ideas on how to get away from a robot dinosaur?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9057c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062568366_Chapter_1.vue
// module id = 66
// module chunks = 0